import { useEffect, useState } from 'react';
import { RunnerGoal, saveRunnerGoal } from '../api/client';
import { haptic } from '../lib/telegram';
import './RunnerGoalCard.css';

const labels = {
  five_k: 'Подготовка к 5 км',
  ten_k: 'Подготовка к 10 км',
  half_marathon: 'Полумарафон',
  lower_hr: 'Снизить пульс на темпе',
  consistency: 'Регулярность'
};

export const RunnerGoalCard: React.FC<{
  userId: number;
  goal: RunnerGoal | null;
  onSaved: (goal: RunnerGoal) => void;
}> = ({ userId, goal, onSaved }) => {
  const [editing, setEditing] = useState(!goal);
  const [type, setType] = useState<RunnerGoal['goal_type']>(goal?.goal_type || 'ten_k');
  const [date, setDate] = useState(goal?.target_date || '');
  const [days, setDays] = useState(goal?.weekly_days || 3);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!goal) return;
    setType(goal.goal_type); setDate(goal.target_date || ''); setDays(goal.weekly_days);
  }, [goal]);

  const save = async () => {
    setSaving(true);
    try {
      const saved = await saveRunnerGoal(userId, {
        goal_type: type, target_date: date || undefined, target_value: undefined, weekly_days: days
      });
      onSaved(saved); setEditing(false); haptic.success();
    } finally { setSaving(false); }
  };

  if (!editing && goal) return (
    <section className="runner-goal-card compact">
      <div><span>ГЛАВНАЯ ЦЕЛЬ</span><h2>{labels[goal.goal_type]}</h2><p>{goal.weekly_days} тренировочных дня в неделю{goal.target_date ? ` · до ${goal.target_date.split('-').reverse().join('.')}` : ''}</p></div>
      <button onClick={() => setEditing(true)}>Изменить</button>
    </section>
  );

  return (
    <section className="runner-goal-card">
      <span>ГЛАВНАЯ ЦЕЛЬ</span><h2>К чему готовимся</h2>
      <div className="goal-form">
        <label>Цель<select value={type} onChange={event => setType(event.target.value as RunnerGoal['goal_type'])}>{Object.entries(labels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label>
        <label>Дата<input type="date" value={date} onChange={event => setDate(event.target.value)} /></label>
        <label>Дней в неделю<input type="number" min="2" max="7" value={days} onChange={event => setDays(Number(event.target.value))} /></label>
      </div>
      <div className="goal-actions"><button onClick={save} disabled={saving}>{saving ? 'Сохраняем…' : 'Сохранить цель'}</button>{goal && <button onClick={() => setEditing(false)}>Отмена</button>}</div>
    </section>
  );
};
